import {
  OPERATOR_TYPES_1,
  OPERATOR_TYPES_2,
  OPERATOR_TYPES_3,
  OPERATOR_TYPES_4,
  OPERATOR_TYPES_6,
} from './operators';

export const AUTOMATIONS = {
  message_created: {
    conditions: [
      {
        key: 'message_type',
        name: 'MESSAGE_TYPE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'content',
        name: 'MESSAGE_CONTAINS',
        inputType: 'comma_separated_plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'add_label',
        name: 'ADD_LABEL',
      },
      {
        key: 'remove_label',
        name: 'REMOVE_LABEL',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'create_kanban_item',
        name: 'CREATE_KANBAN_ITEM',
      },
      {
        key: 'move_kanban_item_to_stage',
        name: 'MOVE_KANBAN_ITEM_TO_STAGE',
      },
      {
        key: 'assign_agent_to_kanban_item',
        name: 'ASSIGN_AGENT_TO_KANBAN_ITEM',
      },
      {
        key: 'add_note_to_kanban_item',
        name: 'ADD_NOTE_TO_KANBAN_ITEM',
      },
      {
        key: 'start_kanban_item_timer',
        name: 'START_KANBAN_ITEM_TIMER',
      },
      {
        key: 'stop_kanban_item_timer',
        name: 'STOP_KANBAN_ITEM_TIMER',
      },
      {
        key: 'enable_toggle_ai',
        name: 'ENABLE_TOGGLE_AI',
      },
      {
        key: 'disable_toggle_ai',
        name: 'DISABLE_TOGGLE_AI',
      },
      {
        key: 'assign_ai_agent',
        name: 'ASSIGN_AI_AGENT',
      },
      {
        key: 'link_offer_to_kanban_item',
        name: 'LINK_OFFER_TO_KANBAN_ITEM',
      },
    ],
  },
  conversation_created: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'create_kanban_item',
        name: 'CREATE_KANBAN_ITEM',
      },
      {
        key: 'move_kanban_item_to_stage',
        name: 'MOVE_KANBAN_ITEM_TO_STAGE',
      },
      {
        key: 'assign_agent_to_kanban_item',
        name: 'ASSIGN_AGENT_TO_KANBAN_ITEM',
      },
      {
        key: 'add_note_to_kanban_item',
        name: 'ADD_NOTE_TO_KANBAN_ITEM',
      },
      {
        key: 'start_kanban_item_timer',
        name: 'START_KANBAN_ITEM_TIMER',
      },
      {
        key: 'stop_kanban_item_timer',
        name: 'STOP_KANBAN_ITEM_TIMER',
      },
      {
        key: 'enable_toggle_ai',
        name: 'ENABLE_TOGGLE_AI',
      },
      {
        key: 'disable_toggle_ai',
        name: 'DISABLE_TOGGLE_AI',
      },
      {
        key: 'assign_ai_agent',
        name: 'ASSIGN_AI_AGENT',
      },
      {
        key: 'link_offer_to_kanban_item',
        name: 'LINK_OFFER_TO_KANBAN_ITEM',
      },
    ],
  },
  conversation_updated: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'create_kanban_item',
        name: 'CREATE_KANBAN_ITEM',
      },
      {
        key: 'move_kanban_item_to_stage',
        name: 'MOVE_KANBAN_ITEM_TO_STAGE',
      },
      {
        key: 'assign_agent_to_kanban_item',
        name: 'ASSIGN_AGENT_TO_KANBAN_ITEM',
      },
      {
        key: 'add_note_to_kanban_item',
        name: 'ADD_NOTE_TO_KANBAN_ITEM',
      },
      {
        key: 'start_kanban_item_timer',
        name: 'START_KANBAN_ITEM_TIMER',
      },
      {
        key: 'stop_kanban_item_timer',
        name: 'STOP_KANBAN_ITEM_TIMER',
      },
      {
        key: 'enable_toggle_ai',
        name: 'ENABLE_TOGGLE_AI',
      },
      {
        key: 'disable_toggle_ai',
        name: 'DISABLE_TOGGLE_AI',
      },
      {
        key: 'assign_ai_agent',
        name: 'ASSIGN_AI_AGENT',
      },
      {
        key: 'link_offer_to_kanban_item',
        name: 'LINK_OFFER_TO_KANBAN_ITEM',
      },
    ],
  },
  conversation_opened: {
    conditions: [
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'enable_toggle_ai',
        name: 'ENABLE_TOGGLE_AI',
      },
      {
        key: 'disable_toggle_ai',
        name: 'DISABLE_TOGGLE_AI',
      },
      {
        key: 'assign_ai_agent',
        name: 'ASSIGN_AI_AGENT',
      },
    ],
  },
  conversation_resolved: {
    conditions: [
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'create_kanban_item',
        name: 'CREATE_KANBAN_ITEM',
      },
      {
        key: 'move_kanban_item_to_stage',
        name: 'MOVE_KANBAN_ITEM_TO_STAGE',
      },
      {
        key: 'assign_agent_to_kanban_item',
        name: 'ASSIGN_AGENT_TO_KANBAN_ITEM',
      },
      {
        key: 'add_note_to_kanban_item',
        name: 'ADD_NOTE_TO_KANBAN_ITEM',
      },
      {
        key: 'start_kanban_item_timer',
        name: 'START_KANBAN_ITEM_TIMER',
      },
      {
        key: 'stop_kanban_item_timer',
        name: 'STOP_KANBAN_ITEM_TIMER',
      },
      {
        key: 'enable_toggle_ai',
        name: 'ENABLE_TOGGLE_AI',
      },
      {
        key: 'disable_toggle_ai',
        name: 'DISABLE_TOGGLE_AI',
      },
      {
        key: 'assign_ai_agent',
        name: 'ASSIGN_AI_AGENT',
      },
      {
        key: 'link_offer_to_kanban_item',
        name: 'LINK_OFFER_TO_KANBAN_ITEM',
      },
    ],
  },
  kanban_item_created: {
    conditions: [
      {
        key: 'funnel_id',
        name: 'FUNNEL',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'funnel_stage',
        name: 'FUNNEL_STAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'kanban_item_status',
        name: 'KANBAN_ITEM_STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'kanban_item_assignee_id',
        name: 'KANBAN_ITEM_ASSIGNEE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'kanban_item_priority',
        name: 'KANBAN_ITEM_PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'kanban_item_value',
        name: 'KANBAN_ITEM_VALUE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_4,
      },
      {
        key: 'kanban_item_product',
        name: 'KANBAN_ITEM_PRODUCT',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'kanban_item_labels',
        name: 'KANBAN_ITEM_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'move_kanban_item_to_stage',
        name: 'MOVE_KANBAN_ITEM_TO_STAGE',
      },
      {
        key: 'assign_agent_to_kanban_item',
        name: 'ASSIGN_AGENT_TO_KANBAN_ITEM',
      },
      {
        key: 'add_note_to_kanban_item',
        name: 'ADD_NOTE_TO_KANBAN_ITEM',
      },
      {
        key: 'start_kanban_item_timer',
        name: 'START_KANBAN_ITEM_TIMER',
      },
      {
        key: 'stop_kanban_item_timer',
        name: 'STOP_KANBAN_ITEM_TIMER',
      },
      {
        key: 'link_offer_to_kanban_item',
        name: 'LINK_OFFER_TO_KANBAN_ITEM',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'add_label',
        name: 'ADD_LABEL',
      },
      {
        key: 'remove_label',
        name: 'REMOVE_LABEL',
      },
      {
        key: 'create_conversation',
        name: 'CREATE_CONVERSATION',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'enable_toggle_ai',
        name: 'ENABLE_TOGGLE_AI',
      },
      {
        key: 'disable_toggle_ai',
        name: 'DISABLE_TOGGLE_AI',
      },
      {
        key: 'assign_ai_agent',
        name: 'ASSIGN_AI_AGENT',
      },
    ],
  },
  kanban_item_stage_changed: {
    conditions: [
      {
        key: 'funnel_id',
        name: 'FUNNEL',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'funnel_stage',
        name: 'FUNNEL_STAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'kanban_item_status',
        name: 'KANBAN_ITEM_STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'kanban_item_assignee_id',
        name: 'KANBAN_ITEM_ASSIGNEE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'kanban_item_priority',
        name: 'KANBAN_ITEM_PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'kanban_item_value',
        name: 'KANBAN_ITEM_VALUE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_4,
      },
      {
        key: 'kanban_item_product',
        name: 'KANBAN_ITEM_PRODUCT',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'kanban_item_labels',
        name: 'KANBAN_ITEM_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'move_kanban_item_to_stage',
        name: 'MOVE_KANBAN_ITEM_TO_STAGE',
      },
      {
        key: 'assign_agent_to_kanban_item',
        name: 'ASSIGN_AGENT_TO_KANBAN_ITEM',
      },
      {
        key: 'add_note_to_kanban_item',
        name: 'ADD_NOTE_TO_KANBAN_ITEM',
      },
      {
        key: 'start_kanban_item_timer',
        name: 'START_KANBAN_ITEM_TIMER',
      },
      {
        key: 'stop_kanban_item_timer',
        name: 'STOP_KANBAN_ITEM_TIMER',
      },
      {
        key: 'link_offer_to_kanban_item',
        name: 'LINK_OFFER_TO_KANBAN_ITEM',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'add_label',
        name: 'ADD_LABEL',
      },
      {
        key: 'remove_label',
        name: 'REMOVE_LABEL',
      },
      {
        key: 'create_conversation',
        name: 'CREATE_CONVERSATION',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'enable_toggle_ai',
        name: 'ENABLE_TOGGLE_AI',
      },
      {
        key: 'disable_toggle_ai',
        name: 'DISABLE_TOGGLE_AI',
      },
      {
        key: 'assign_ai_agent',
        name: 'ASSIGN_AI_AGENT',
      },
    ],
  },
};

export const AUTOMATION_RULE_EVENTS = [
  {
    key: 'conversation_created',
    value: 'CONVERSATION_CREATED',
  },
  {
    key: 'conversation_updated',
    value: 'CONVERSATION_UPDATED',
  },
  {
    key: 'conversation_resolved',
    value: 'CONVERSATION_RESOLVED',
  },
  {
    key: 'message_created',
    value: 'MESSAGE_CREATED',
  },
  {
    key: 'conversation_opened',
    value: 'CONVERSATION_OPENED',
  },
  {
    key: 'kanban_item_created',
    value: 'KANBAN_ITEM_CREATED',
  },
  {
    key: 'kanban_item_stage_changed',
    value: 'KANBAN_ITEM_STAGE_CHANGED',
  },
];

export const AUTOMATION_ACTION_TYPES = [
  {
    key: 'assign_agent',
    label: 'ASSIGN_AGENT',
    inputType: 'search_select',
  },
  {
    key: 'assign_team',
    label: 'ASSIGN_TEAM',
    inputType: 'search_select',
  },
  {
    key: 'add_label',
    label: 'ADD_LABEL',
    inputType: 'multi_select',
  },
  {
    key: 'remove_label',
    label: 'REMOVE_LABEL',
    inputType: 'multi_select',
  },
  {
    key: 'send_email_to_team',
    label: 'SEND_EMAIL_TO_TEAM',
    inputType: 'team_message',
  },
  {
    key: 'send_email_transcript',
    label: 'SEND_EMAIL_TRANSCRIPT',
    inputType: 'email',
  },
  {
    key: 'mute_conversation',
    label: 'MUTE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'snooze_conversation',
    label: 'SNOOZE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'resolve_conversation',
    label: 'RESOLVE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'open_conversation',
    label: 'OPEN_CONVERSATION',
    inputType: null,
  },
  {
    key: 'send_webhook_event',
    label: 'SEND_WEBHOOK_EVENT',
    inputType: 'url',
  },
  {
    key: 'send_attachment',
    label: 'SEND_ATTACHMENT',
    inputType: 'attachment',
  },
  {
    key: 'send_message',
    label: 'SEND_MESSAGE',
    inputType: 'textarea',
  },
  {
    key: 'add_private_note',
    label: 'ADD_PRIVATE_NOTE',
    inputType: 'textarea',
  },
  {
    key: 'change_priority',
    label: 'CHANGE_PRIORITY',
    inputType: 'search_select',
  },
  {
    key: 'add_sla',
    label: 'ADD_SLA',
    inputType: 'search_select',
  },
  {
    key: 'create_kanban_item',
    label: 'CREATE_KANBAN_ITEM',
    inputType: 'funnel_stage',
  },
  {
    key: 'move_kanban_item_to_stage',
    label: 'MOVE_KANBAN_ITEM_TO_STAGE',
    inputType: 'funnel_stage',
  },
  {
    key: 'assign_agent_to_kanban_item',
    label: 'ASSIGN_AGENT_TO_KANBAN_ITEM',
    inputType: 'search_select',
  },
  {
    key: 'add_note_to_kanban_item',
    label: 'ADD_NOTE_TO_KANBAN_ITEM',
    inputType: 'textarea',
  },
  {
    key: 'start_kanban_item_timer',
    label: 'START_KANBAN_ITEM_TIMER',
    inputType: null,
  },
  {
    key: 'stop_kanban_item_timer',
    label: 'STOP_KANBAN_ITEM_TIMER',
    inputType: null,
  },
  {
    key: 'enable_toggle_ai',
    label: 'ENABLE_TOGGLE_AI',
    inputType: null,
  },
  {
    key: 'disable_toggle_ai',
    label: 'DISABLE_TOGGLE_AI',
    inputType: null,
  },
  {
    key: 'assign_ai_agent',
    label: 'ASSIGN_AI_AGENT',
    inputType: 'search_select',
  },
  {
    key: 'link_offer_to_kanban_item',
    label: 'LINK_OFFER_TO_KANBAN_ITEM',
    inputType: 'search_select',
  },
  {
    key: 'create_conversation',
    label: 'CREATE_CONVERSATION',
    inputType: 'search_select',
  },
];
